import { render, staticRenderFns } from "./Donations.vue?vue&type=template&id=73ffae94"
import script from "./Donations.vue?vue&type=script&lang=js"
export * from "./Donations.vue?vue&type=script&lang=js"
import style0 from "./Donations.vue?vue&type=style&index=0&id=73ffae94&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports